module.exports = __webpack_public_path__ + "static/tri-screen-lockup-v2-ee69a5a5197c2419abaf90bb19d884c7.png";